module.exports = __webpack_public_path__ + "static/media/pet_care_support.438c89cc.svg";